<template>
  <div class="mianCtn">
    <div class="leftCtn">
      <div class="mapPanel">
        <pl-lazy>
            <main-map
            ref="mainmap"
            :lyrdata="lyrdata"
            :mapCtrlTools="mapCtrlTools4Use"
            :mapParams="mapParams"
            :showBottomBar="false"
            :showSearchBar="false"
            :showVector="false"
            :showMeasure="false"
            >
            </main-map>
          </pl-lazy>
          <div class="areaButton1" style="left: calc(100vw - 705px);top: 20px;" v-if="!showVectorTileLayer">显示拍摄时间</div>
          <div class="areaButton1-s" style="left: calc(100vw - 705px);top: 20px;" v-if="showVectorTileLayer" @click="showVectorLayer()">{{showImageTime}}</div>
          <div class="redHint">提示：红色区域因拍摄期间有云，已使用往期切片影像替换。</div>
      </div>
    </div>
    <div class="rightCtn">
      <div class="rightTitle">
        购买专业版套件
      </div>
      <v-tabs v-model="curPlaceTab" grow class="vtabs" style="width: 560px;" color="#000000">
        <v-tab key="place" @click="tabSel=1;cancelArea()">
          <img src="../../assets/buyCountyProduction/选择行政区域-亮.png" alt="" style="margin-right: 5px;width:14px ;" v-if="tabSel==1">
          <img src="../../assets/buyCountyProduction/选择行政区域-暗.png" alt="" style="margin-right: 5px;width:14px ;" v-if="tabSel!=1">
          <span style="font-size: 14px;">选择行政区域</span>
        </v-tab>
        <v-tab key="explainPlace" @click="tabSel=2;cancelArea()">
          <img src="../../assets/buyCountyProduction/搜索-亮.png" alt="" style="margin-right: 5px;width:17px ;" v-if="tabSel==2">
          <img src="../../assets/buyCountyProduction/搜索-按.png" alt="" style="margin-right: 5px;width:17px ;" v-if="tabSel!=2">
          <span style="font-size: 14px;">搜索行政区域</span>
        </v-tab>
        <v-tab key="drawArea" @click="tabSel=3;areaSel=0;cancelArea()">
          <img src="../../assets/buyCountyProduction/绘制区域-亮.png" alt="" style="margin-right: 5px;width:15px ;" v-if="tabSel==3">
          <img src="../../assets/buyCountyProduction/绘制区域-暗.png" alt="" style="margin-right: 5px;width:15px ;" v-if="tabSel!=3">
          <span style="font-size: 14px;">绘制区域</span>
          <!-- <img src="../../assets/newHome/双十一.png" alt="" style="width: 20px;display:inline-block;margin-top: -27px;margin-left: -10px;"> -->

        </v-tab>
        <v-tab key="uploadVector" @click="tabSel=4;cancelArea()">
          <img src="../../assets/buyCountyProduction/上传矢量-亮 .png" alt="" style="margin-right: 5px;width:15px ;" v-if="tabSel==4">
          <img src="../../assets/buyCountyProduction/上传矢量-暗.png" alt="" style="margin-right: 5px;width:15px ;" v-if="tabSel!=4">
          <span style="font-size: 14px;">上传矢量</span>
        </v-tab>
        <v-tab-item key="place">
          <v-row justify="start" class="ma-2" style="padding-top: 20px;">
            <div style="width: 143px">
              <v-autocomplete ref="chinaProvince" class="ma-0 mr-2"
                              :items="chinaProvinceItems" item-text="areaName" item-value="areaId"
                              :label="$vuetify.lang.t('$vuetify.search.rangeSelector.province')"
                              v-model="chinaProvinceNow" outlined dense>
              </v-autocomplete>
            </div>
            <div style="width: 143px">
              <v-autocomplete ref="chinaCity" class="ma-0 mr-2" :disabled="!chinaProvinceNow"
                              :items="chinaCityItems" item-text="areaName" item-value="areaId"
                              :label="$vuetify.lang.t('$vuetify.search.rangeSelector.city')"
                              v-model="chinaCityNow" outlined dense>
              </v-autocomplete>
            </div>
            <div style="width: 143px">
              <v-autocomplete ref="chinaCounty" class="ma-0" :disabled="!chinaCityNow"
                              :items="chinaCountyItems" item-text="areaName" item-value="areaId"
                              :label="$vuetify.lang.t('$vuetify.search.rangeSelector.county')"
                              v-model="chinaCountyNow" outlined dense>
              </v-autocomplete>
            </div>
            <div v-if="chinaProvinceNow" @click="searchCountyById"
                style="cursor: pointer;width: 100px;height: 44px;background: #0066CC;border-radius: 8px;margin-left:10px;color:white;display: flex;align-items: center;justify-content: center;z-index: 1;">
              查询
            </div>
            <div v-else
                style="cursor: pointer;width: 100px;height: 44px;background: #CCCCCC;border-radius: 8px;color:white;display: flex;align-items: center;margin-left:10px;justify-content: center;z-index: 1;">
              查询
            </div>
          </v-row>


          <!-- </v-card> -->
        </v-tab-item>
        <v-tab-item key="explainPlace" style="position:relative">
          <div class="searchField">
            <v-text-field
                v-model="countyName"
                outlined
                clearable
                label="请输入区县名*"
                append-icon="mdi-magnify"
                @input="searchCountyByName"
                style="width: 394px;height: 75px;border-radius: 8px;"
            ></v-text-field>
            <div v-if="countyName" @click="showDetail"
                style="cursor: pointer;width: 100px;margin-left:20px;height: 44px;background: #0066CC;border-radius: 8px;color:white;display: flex;align-items: center;justify-content: center;">
              查询
            </div>
            <div v-else
                style="cursor: pointer;width: 100px;height: 44px;background: #CCCCCC;margin-left:20px;border-radius: 8px;color:white;display: flex;align-items: center;justify-content: center;">
              查询
            </div>
          </div>
        </v-tab-item>
        <v-tab-item key="drawArea" style="position:relative">
          <div class="drawAreaCon">
            <img src="../../assets/buyCountyProduction/25km²-2.png" alt="" class="areaSel" style="margin-left: 15px;" v-if="areaSel!=2" @click="areaSel=2">
            <img src="../../assets/buyCountyProduction/25km²-1.png" alt="" class="areaSel" style="margin-left: 15px;" v-if="areaSel==2">
            <img src="../../assets/buyCountyProduction/矩形-暗.png" alt="" class="areaSel" v-if="areaSel!=1" @click="areaSel=1">
            <img src="../../assets/buyCountyProduction/矩形-亮.png" alt="" class="areaSel" v-if="areaSel==1">
            <img src="../../assets/buyCountyProduction/多边形-暗.png" alt="" class="areaSel" v-if="areaSel!=3" @click="areaSel=3">
            <img src="../../assets/buyCountyProduction/多边形-亮.png" alt="" class="areaSel" v-if="areaSel==3">
            <div class="areaButtonCon">
              <div class="areaButton1" v-if="!canQueryArea">查询</div>
              <div class="areaButton1-s" v-if="canQueryArea" @click="queryCountyTilesListByShape()">查询</div>
              <div class="areaButton2" v-if="!canQueryArea" @click="cancelArea()">清除</div>
              <div class="areaButton2-s" v-if="canQueryArea" @click="cancelArea()">清除</div>
            </div>
          </div>
          <div class="drawAreaTip">
            <img src="../../assets/buyCountyProduction/感叹号.png" alt="" style="width: 8px;margin-right: 5px;">支持选择最小区域面积为25k㎡，面积不足将自动扩充至25k㎡，矢量宽度不得低于5km
          </div>
        </v-tab-item>
        <v-tab-item key="uploadVector" style="position:relative">
          <div class="drawAreaCon" style="height:105px;">
            <input id="filesForBuy" style="display: none" type="file" ref="clearFile" @change="importFile()" />
            <img src="../../assets/buyCountyProduction/上传文件.png" alt="" class="drawAreaConImg" @click="changeFn()">
            <div class="areaButtonCon">
              <div class="areaButton1" v-if="!canQueryVector">查询</div>
              <div class="areaButton1-s" v-if="canQueryVector" @click="queryCountyTilesListByShape()">查询</div>
              <div class="areaButton2" v-if="!canQueryVector" @click="cancelArea()">清除</div>
              <div class="areaButton2-s" v-if="canQueryVector" @click="cancelArea()">清除</div>
            </div>
            <div class="drawAreaTip" style="position:absolute;bottom:0px;">
              <img src="../../assets/buyCountyProduction/感叹号.png" alt="" style="width: 8px;margin-right: 5px;">支持选择最小区域面积为25k㎡，面积不足将自动扩充至25k㎡，矢量宽度不得低于5km
            </div>
          </div>

        </v-tab-item>
      </v-tabs>
      <div v-if="foreanHint" class="foreanHintText">选取失败，目前仅支持中国大陆境内的区域</div>
      <div style="width: 560px;position:relative;margin-left: 17px;" v-if="tabSel==2">
        <a-list class="priceResultList" item-layout="horizontal" :data-source="priceResult" v-if="priceResult.length>0" style="z-index: 1000">
          <a-list-item class="searchListItem" slot="renderItem" slot-scope="item">
            <div>
              <a @click="selectExplainPlace(item)">{{item.completeArea }}</a>
            </div>
          </a-list-item>
        </a-list>
      </div>
      <div style="width:560px;border-bottom:1px dashed rgba(0,0,0,.1);margin:10px 20px 0 20px;z-index:1"></div>
      <div class="detail" v-if="showCountyNameResult&&countyNameResult&&(tabSel==1||tabSel==2)">
        <div class="item">
          <div>区域名称<span>{{ countyNameResult }}</span></div>
          <div>区域面积<span>{{ countyAreaResult.toFixed(3) }}</span><span>km²</span></div>
          <div style="width: 100%;display: flex;justify-content: space-between;padding-right: 5px;">
            <div style="width: 200px;">
              请选择（支持多选）
            </div>
            <div @click="illustrateDialog=true;" style="width: 200px;text-align: right;color:#0066CC;cursor:pointer;">
              专业版套件价格说明
            </div>
          </div>
        </div>
      </div>
      <!-- 绘制区域改名 -->
      <div class="detail" v-if="showCountyNameResult&&countyNameResult&&(tabSel==3||tabSel==4)">
        <div class="item">
          <div>
            <div class="itemText" id="itemTextId">区域名称</div><span style="position: absolute;top: -5px;left:48px;font-size: 12px;color: #F35656;">*</span>
            <input type="text" class="areaNameInput" v-model="customizeName" id="areaNameInputId" @change="customizeNameAdd()" maxlength="30">
            <div class="itemTip" v-if="customizeName.length>36">
            <img src="../../assets/buyCountyProduction/感叹号.png" alt="" style="width: 8px;margin-right: 5px;">区域名称字数不超过30字
            </div>
          </div>
          <div>区域面积<span>{{ countyAreaResult.toFixed(3) }}</span><span>km²</span></div>
          <div style="width: 100%;display: flex;justify-content: space-between;padding-right: 5px;">
            <div style="width: 200px;">
              请选择（支持多选）
            </div>
            <div @click="illustrateDialog=true;" style="width: 200px;text-align: right;color:#0066CC;cursor:pointer;">
              专业版套件价格说明
            </div>
          </div>
        </div>
      </div>
      <v-tabs v-model="yearSelectTab" v-if="showCountyNameResult&&countyNameResult" class="vtabs vtabs-year-select" style="width: 560px" color="#000000">
        <v-tab key="2026year" class="year-version-tab">
          <span class="year-tab-text">2026版</span>
        </v-tab>
        <v-tab key="2025year" class="year-version-tab">
          <span class="year-tab-text">2025版</span>
        </v-tab>
        <v-tab key="2024year" class="year-version-tab">
          <span class="year-tab-text">2024版</span>
        </v-tab>
        <v-tab key="2023year" class="year-version-tab">
          <span class="year-tab-text">2023版</span>
        </v-tab>
        <v-tab-item key="2026year">
          <div class="quarterSelectCtn" v-if="showCountyNameResult&&countyNameResult">
            <div v-for="(item,i) in quanterListByYear(2026)" @click="clickQuanterItem(item)" :class="selectedQuanterIds.indexOf(item.subName)> -1 ? 'selectItem-selected':'selectItem'" :key="item.areaName+i">
              {{item.subName}} 限时价格 ￥<span style="color:#ff4040">{{ item.price }}</span>
              <img class="icon" v-if="selectedQuanterIds.indexOf(item.subName)> -1" src="../../assets/rsStandard/季度已选中.png" style="" height="16" width="16"/>
              <img class="icon" v-else src="../../assets/rsStandard/季度未选中.png" style="" height="16" width="16"/>
            </div>
            <div v-if="quanterListByYear(2026).length < 4 && (beijingOrder || !quanterListByYear(2026).length < 3)" class="selectItem" style="border:solid 1px #B8B8B8">
              <span style="color:#B8B8B8">2026年第二季度 预计2026年7月推出</span>
            </div>
            <div v-if="quanterListByYear(2026).length < 5 && (beijingOrder || !quanterListByYear(2026).length < 4)" class="selectItem" style="border:solid 1px #B8B8B8">
              <span style="color:#B8B8B8">2026年第三季度 预计2026年10月推出</span>
            </div>
            <div v-if="quanterListByYear(2026).length < 6 && (beijingOrder || !quanterListByYear(2026).length < 5)" class="selectItem" style="border:solid 1px #B8B8B8">
              <span style="color:#B8B8B8">2026年第四季度 预计2027年1月推出</span>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item key="2025year">
          <div class="quarterSelectCtn" v-if="showCountyNameResult&&countyNameResult">
            <div v-for="(item,i) in quanterListByYear(2025)" @click="clickQuanterItem(item)" :class="selectedQuanterIds.indexOf(item.subName)> -1 ? 'selectItem-selected':'selectItem'" :key="item.areaName+i">
              {{item.subName}} 限时价格 ￥<span style="color:#ff4040">{{ item.price }}</span>
              <img class="icon" v-if="selectedQuanterIds.indexOf(item.subName)> -1" src="../../assets/rsStandard/季度已选中.png" style="" height="16" width="16"/>
              <img class="icon" v-else src="../../assets/rsStandard/季度未选中.png" style="" height="16" width="16"/>
            </div>
<!--            <div v-if="areaQuanterList.length < 13 && (beijingOrder || !areaQuanterList.length < 12)" class="selectItem" style="border:solid 1px #B8B8B8">-->
<!--              <span style="color:#B8B8B8">2025年第四期（7-8月） 预计2025年9月推出</span>-->
<!--            </div>-->
            <!-- <div v-if="areaQuanterList.length < 14 && (beijingOrder || !areaQuanterList.length < 13)" class="selectItem" style="border:solid 1px #B8B8B8">
              <span style="color:#B8B8B8">2025年第五期（9-10月） 预计2025年11月推出</span>
            </div> -->
            <!-- <div v-if="areaQuanterList.length < 15 && (beijingOrder || !areaQuanterList.length < 14)" class="selectItem" style="border:solid 1px #B8B8B8">
              <span style="color:#B8B8B8">2025年第六期（11-12月） 预计2026年1月推出</span>
            </div> -->
          </div>
        </v-tab-item>
        <v-tab-item key="2024year">
          <div class="quarterSelectCtn" v-if="showCountyNameResult&&countyNameResult">
            <div v-for="(item,i) in quanterListByYear(2024)" @click="clickQuanterItem(item)" :class="selectedQuanterIds.indexOf(item.subName)> -1 ? 'selectItem-selected':'selectItem'" :key="item.areaName+i">
              {{item.subName}} 限时价格 ￥<span style="color:#ff4040">{{ item.price }}</span>
              <img class="icon" v-if="selectedQuanterIds.indexOf(item.subName)> -1" src="../../assets/rsStandard/季度已选中.png" style="" height="16" width="16"/>
              <img class="icon" v-else src="../../assets/rsStandard/季度未选中.png" style="" height="16" width="16"/>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item key="2023year" style="position:relative">
          <div class="quarterSelectCtn" v-if="showCountyNameResult&&countyNameResult">
            <div v-for="(item,i) in quanterListByYear(2023)" @click="clickQuanterItem(item)" :class="selectedQuanterIds.indexOf(item.subName)> -1 ? 'selectItem-selected':'selectItem'" :key="item.areaName+i">
              {{item.subName}} 限时价格 ￥<span style="color:#ff4040">{{ item.price }}</span>
              <img class="icon" v-if="selectedQuanterIds.indexOf(item.subName)> -1" src="../../assets/rsStandard/季度已选中.png" style="" height="16" width="16"/>
              <img class="icon" v-else src="../../assets/rsStandard/季度未选中.png" style="" height="16" width="16"/>
            </div>
          </div>
        </v-tab-item>
      </v-tabs>

      <div class="commitCtn" v-if="showCountyNameResult&&countyNameResult">
        <div style="width: 110px;height:45px;line-height: 45px;">
          下单后即时交付
        </div>
        <div
            style="width: 200px;height:45px;line-height: 45px;text-align: right;margin-right: 10px;margin-left: 130px;">
          共计 ￥<span style="color:#FF4040">{{selectedSumPrices}}</span>
        </div>
        <div v-if="selectedQuanterItems.length>0&&(((tabSel==3||tabSel==4)&&customizeName.length>6&&customizeName.slice(-6)=='（自选区域）')||(tabSel==1||tabSel==2))" @click="nextStep" style="cursor: pointer;width: 100px;margin-left:20px;height: 44px;background: #0066CC;border-radius: 8px;color:white;display: flex;align-items: center;justify-content: center;">
          下一步
        </div>
        <div v-else style="cursor: pointer;width: 100px;margin-left:20px;height: 44px;background: #CCCCCC;border-radius: 8px;color:white;display: flex;align-items: center;justify-content: center;">
          下一步
        </div>
      </div>
      <div :class="showCountyNameResult&&countyNameResult ? 'bottomTip':'bottomTipAboslute'">
        若您有任何疑问请咨询商务经理：0431-86008580
      </div>
    </div>
    <!--产品价格说明弹窗-->
    <div v-if="illustrateDialog" class="dialogMantle">
      <div class="dialogCtn">
        <img @click="illustrateDialog=false;" src="../../assets/rsStandard/关闭弹窗.png" height="40" width="40"/>
        <div class="dialogTitle" style="margin-top: 50px;">
          专业版产品计费规则
        </div>
        <div class="dialogTxt1" style="margin-top: 50px;">
          2026年每季度一期、2025年每两个月一期（0.5m分辨率）：<br>选择行政区域情形的价格为￥10/km²/年，自定义矢量（绘制区域、上传矢量）情形的价格为￥13/km²/年
        </div>
        <div class="dialogTxt1" style="margin-top: 30px;">
          2024、2023年每季度一期（0.75m分辨率）：<br>选择行政区域情形的价格为￥3/km²/年，自定义矢量（绘制区域、上传矢量）情形的价格为￥4/km²/年
        </div>
        <!-- <div class="dialogTxt">
          区/县拍摄频次等因素综合确定，用户付款价格以最终报价为准。
        </div> -->
        <div class="dialogTxt" style="margin-top:70px;">
          如有您对价格存疑，请联系商务经理：0431-86008580 ( 非节假日 08:30 ~ 17:30 )
        </div>
        <div @click="illustrateDialog=false;" style="cursor: pointer;width: 100px;height: 40px;line-height:40px;text-align:center;background: #0066CC;border-radius: 8px;color:white;margin-left: auto;margin-right: auto;margin-top: 25px;">
          关闭
        </div>

      </div>
    </div>
    <!-- 认证身份弹窗 -->
    <div class="shadow" v-if="shadowTip">
      <div class="shadowWhite">
          <img src="../../assets/newHome/日历关闭.png" alt="" class="shadowClose" @click="shadowTip=false">
          <div class="shadowText1">用户身份认证</div>
          <div class="shadowText2">根据国家地理信息安全与保密相关规定，为规范数据使用，保障您的合法权益，购买和使用卫星遥感数据需完成<span style="font-weight: 600;">机构企业用户</span>/<span style="font-weight: 600;">教育科研用户</span>认证。（认证后可享受会员价格）</div>
          <div class="shadowSel" @click="jumpWithPermission('可游客','/store/ApplyGovernmentMember','/rskit')">
              <img src="../../assets/buyCountyProduction/企业用户.png" alt="" style="position: absolute;width: 100%;height: 100%;">
          </div>
          <div class="shadowSel" @click="jumpWithPermission('可游客','/store/OpenEducationalCertification','/rskit')" style="left: 400px;">
              <img src="../../assets/buyCountyProduction/教育用户.png" alt="" style="position: absolute;width: 100%;height: 100%;">
          </div>
      </div>
  </div>
  <!-- 机构企业：授权委托书（与 Purchase 一致） -->
  <div v-if="authLetterModalVisible" class="authLetterLayer">
    <div class="authLetterShadow" @click.self="closeAuthLetterModal">
        <div class="authLetterModal" @click.stop>
            <img src="../../assets/newHome/日历关闭.png" alt="" class="authLetterClose" @click="closeAuthLetterModal">
            <div class="authLetterTitle">{{ authLetterTitle }}</div>
            <div class="authLetterDesc" v-if="authLetterModalMode!=='rejected'">{{ authLetterBodyText }}</div>
            <template v-else>
                <div class="authLetterDesc">很抱歉，您的授权委托书未通过审核，请重新上传。</div>
                <div class="authLetterReject" v-if="authorizationLetterRejectReason">未通过原因：{{ authorizationLetterRejectReason }}</div>
            </template>
            <div
                class="authLetterDrop"
                :class="{ 'authLetterDrop--active': authLetterDragOver }"
                @click="triggerAuthFileInput"
                @dragover.prevent="onAuthDragOver"
                @dragleave.prevent="onAuthDragLeave"
                @drop.prevent="onAuthFileDrop"
            >
                <input
                    ref="authFileInput"
                    type="file"
                    class="authLetterFileInput"
                    accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                    @change="onAuthFileChange"
                >
                <div class="authLetterDropIcon" aria-hidden="true">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" fill="#1E81EB" fill-opacity="0.15"/>
                        <path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" stroke="#1E81EB" stroke-width="1.2"/>
                        <path d="M12 9v6M9 12h6" stroke="#1E81EB" stroke-width="1.2" stroke-linecap="round"/>
                    </svg>
                </div>
                <div class="authLetterDropLine1">点击或将文件拖拽到这里上传</div>
                <div class="authLetterDropLine2">支持扩展名：.pdf .jpg .png .jpeg</div>
            </div>
            <div class="authLetterFileRow" v-if="authLetterPendingName">
                <span class="authLetterFileClip">&#128206;</span>
                <span class="authLetterFileName">{{ authLetterPendingName }}</span>
                <span class="authLetterFileRemove" @click.stop="clearAuthFile">×</span>
            </div>
            <div class="authLetterBar" v-if="authLetterPendingName"></div>
            <a
                href="javascript:;"
                class="authLetterLink"
                :class="{ 'authLetterLink--disabled': authLetterTemplateLoading }"
                @click.prevent="downloadAuthLetterTemplate"
            >{{ authLetterTemplateLoading ? '正在获取…' : '点击下载授权委托书模版' }}</a>
            <div class="authLetterBtns">
                <div class="authLetterBtn1" :class="{ 'authLetterBtn1--disabled': authLetterUploading }" @click="confirmAuthLetterAction">{{ authLetterPrimaryLabel }}</div>
                <div class="authLetterBtn2" v-if="!authLetterUploading" @click="closeAuthLetterModal">暂不上传</div>
            </div>
        </div>
    </div>
    <div v-if="authLetterTopTip" class="authLetterTopTip">
        <div
            class="authLetterTopTipInner"
            :class="'authLetterTopTipInner--' + authLetterTopTipType"
        >
            <span class="authLetterTopTipMark" v-if="authLetterTopTipType === 'success'">✓</span>
            <span class="authLetterTopTipMark" v-else>×</span>
            <span class="authLetterTopTipText">{{ authLetterTopTip }}</span>
        </div>
    </div>
  </div>
  </div>

</template>

<script>
import MainMap from '@/components/Maps/MainMap'
import { Vector,Tile } from 'ol/layer';
import { Polygon, LineString, MultiPolygon,MultiLineString,Point } from 'ol/geom'
import Feature from 'ol/Feature';
import { bus } from '@/bus.js' //引入bus.js定义的空的Vue实例
import VectorTileLayer from 'ol/layer/VectorTile';
import { VectorTile } from 'ol/source';
import { MVT, GeoJSON } from 'ol/format';
import { Fill, Stroke, Style, Text } from 'ol/style';
import * as turf from "turf";
import { getCenter } from 'ol/extent'
import { toLonLat } from 'ol/proj'
import booleanContains from '@turf/boolean-contains'
import WKT from "terraformer-wkt-parser"
import flatten from "@turf/flatten";
import {rootUrl} from '@/globalConfig'

export default {
  name: "buyCountyProduction",
  components: {
    MainMap
  },
  data() {
    return {
      areaQuanterList:[],//区县季节列表
      selectedQuanterIds:[],
      selectedQuanterItems:[],
      selectedSumPrices:0,
      illustrateDialog: false,
      yearSelectTab:0,

      //提示相关参数
      snackbar: false,
      snackbarColor: "",
      snackbarInfo: "",
      timeout: 3000,


      curPlaceTab: 0,
      explainPlace: '',//输入-地点
      chinaProvinceNow: '',
      selectedProvinice: '',
      chinaCityNow: '',
      selectedCity: '',
      chinaCountyNow: '',
      selectedCounty: '',
      chinaProvinceItems: [],
      chinaCityItems: [],
      chinaCountyItems: [],
      vtabsWidth: 300,//vtabs的宽度，用于设置v-date-picker的宽度


      countyName: '',
      // detailList: [],
      priceResult: [],//查询结果

      showCountyNameResult: false,
      countyNameResult: '',
      countyAreaResult: '',
      countyQ1CoverRate: '',
      countyQ2CoverRate: '',
      countyQ3CoverRate: '',
      countyQ4CoverRate: '',
      countyQ1Price: '',
      countyQ2Price: '',
      countyQ3Price: '',
      countyQ4Price: '',
      areaGeo: '',
      curyear: '',
      cursort: '',

      lyrdata: [{
          lyrType:"Tile",
          srcType:"XYZ",
          // mUrl:`https://api.jl1mall.com/getMap/{z}/{x}/{-y}?mk=2d9bf902749f1630bc25fc720ba7c29f&tk=0073bef5c4266498b8f18225fe63a3fa&vf=0`,
          mUrl:`https://api.jl1mall.com/getMap/{z}/{x}/{-y}?mk=2d9bf902749f1630bc25fc720ba7c29f&tk=b9ae773d2fc3c91791e9edb2ba114911&vf=0`,
          mTitle:'全球一张图',
          mName:'全球一张图',
          // mExtent:v.extent.split(','),
          mVisible:true
      },
      {
          lyrType:"lVector",
          srcType:"Vector",
          mUrl:'',
          mTitle:"边框",
          mName:"边框",
          mVisible:true
      },],
      mapCtrlTools4Use: [2],
      mapParams: {
          projection:'EPSG:3857', //注意：必须加上此投影才能显示地图，目前有效的是4326和3857，而4490暂未生效
          center:[108.29883, 35.72902], //地图初始化时的中心坐标【基于4326坐标系】
          // center:[142.85524, 43.61710], //地图初始化时的中心坐标【基于4326坐标系】
          // mExtent:[120.45536,35.55856,139.36943,44.78707], //左下点-右上点
          minZoom:1, //可以缩小的最小级别；若此处未定义，地图接收到undefined则表示不受限制
          maxZoom:15, //可以放大的最大级别；若此处未定义，地图接收到undefined则表示不受限制
          zoom:4, //地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
      },
        loadGisMapRunOver: false,//用于判断mainmap是否加载完成

      tabSel:1,
      //矩形1 正方形2 多边形3
      areaSel:0,
      //是否可以查询绘制区域
      canQueryArea:false,
      //是否可以查询上传矢量
      canQueryVector:false,
      //自定义区域名
      customizeName:'辽宁省铁岭市兵山市（自选区域）',
      curmk:"",
      showVectorTileLayer:false,
      vectorTileLayer:null,
      foreanHint:false,
      showImageTime:'显示拍摄时间',
      str_point:'',
      beijingGeo:'',//北京市矢量
      beijingOrder:false,
      shadowTip:false,
      // 授权委托书（与 Purchase 一致）
      authLetterModalVisible: false,
      authLetterModalMode: "initial",
      enterpriseCertInfoId: null,
      authorizationLetterRejectReason: "",
      authLetterPendingFile: null,
      authLetterPendingName: "",
      authLetterUploading: false,
      authLetterDragOver: false,
      authLetterCompanyName: "",
      authLetterCreditCode: "",
      authLetterTemplateLoading: false,
      authLetterTopTip: "",
      authLetterTopTipType: "success",
    };
  },
  computed: {
    authLetterTitle() {
      if (this.authLetterModalMode === "pending") return "授权委托书审核中";
      return "上传授权委托书";
    },
    authLetterBodyText() {
      if (this.authLetterModalMode === "pending") {
        return "您上传的授权委托书正在审核中，请耐心等待。";
      }
      return "根据平台管理要求，机构企业用户购买遥感商城产品需要签署授权委托书并盖章上传，审核通过后可享受专属购买权益。";
    },
    authLetterPrimaryLabel() {
      return this.authLetterModalMode === "initial" ? "确认上传" : "重新上传";
    },
  },
  created() {
  },
  mounted() {
    this.checkScreenWidth();
    let that = this
    window.addEventListener("resize", function () {
      that.checkScreenWidth();
    })
    this.axios.get('/accessapi/searchService/Area/id=-1').then((res) => {
      this.chinaProvinceItems = res.data.data
      this.chinaProvinceItems.forEach(element => {
        if(element.areaName=='北京市') this.beijingGeo = JSON.parse(element.areaGeojson)
      });
    })

    bus.$off('cutImageFinished')
    bus.$on('cutImageFinished',image=>{
      this.$store.state.county.img=image;
      this.$router.push("/demandConfirm");
    })
    bus.$off('buyDrawFinish')
    bus.$on('buyDrawFinish',()=>{
      let ext = this.$refs.mainmap.source.getExtent()
      var center = toLonLat(getCenter(ext));
      let point = turf.point([center[0], center[1]]);
      this.str_point = 'POINT('+center[0]+' '+center[1]+')'
      let boolIntersect = false
      this.$refs.mainmap.chinaJs.features.some(chnElement => {
        if (booleanContains(chnElement, point)) {
          boolIntersect = true
          return true
        }
      });
      if (boolIntersect) {
        this.foreanHint = false
        if(this.tabSel==3)
          this.canQueryArea=true
        else if(this.tabSel==4)
          this.canQueryVector=true
      } else {
        this.foreanHint = true
        this.canQueryArea=false
        this.canQueryVector=false
      }

    })
    setTimeout(() => {
      this.loadVectorTile()
    }, 1000);
    this.getUserData()

  },
  methods: {
    getKey() {
      return localStorage.getItem("token");
    },
    //带权限判断的跳转
    jumpWithPermission(type,path,fromUrl){
            //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
            //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
            let loginUserId=localStorage.getItem('userId');//是否已登录
            let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
            if(type=='可游客'){
                if(fromUrl){
                    window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                    window.open(rootUrl+path,"_self")
                }
            }else if(type=='仅登录'){
                //已登录
                if(loginUserId){
                    if(fromUrl){
                        window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+path,"_self")
                    }
                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }else if(type=='仅实名'){
                //已登录
                if(loginUserId){
                    //已实名
                    if(authentication=='0'){
                        if(fromUrl){
                            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                        }
                        else {
                            window.open(rootUrl+path,"_self")
                        }
                    }
                    //未实名
                    else {
                        window.open(rootUrl+'/Authentication',"_self")
                    }

                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }
    },
    //实名权限检查与处理（遥感商城版）
    checkAndHandleAuthentication(){
      let loginUserId=localStorage.getItem('userId');//是否已登录
      let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
      if(!loginUserId){
        if(localStorage.getItem('preRoute')=="/Login"){
          this.$router.push('/');
        }else {
          setTimeout(()=>{
            this.$router.push('/Login');
          },100)
        }
        return false;
      }
      else if(authentication!='0'){
        if(localStorage.getItem('preRoute')=="/Authentication"){
          setTimeout(()=>{
            this.$router.push('/');
          },100)
        }
        else {
          setTimeout(()=>{
            this.$router.push('/Authentication');
          },100)
          return false;
        }

      }
      return true;
    },
    nextStep() {
      if(!this.$store.state.user.logined){
          this.jumpWithPermission('仅登录','/Login','/rskit/buyCountyProduction')
          return;
        }
      let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
      if(authentication!='0') {
        this.jumpWithPermission('仅实名','/Authentication','/rskit/buyCountyProduction')
        return;
      }
      if(this.countyAreaResult<25&&(this.tabSel==3||this.tabSel==4)){
        this.$refs.mainmap.snackbar=true
        this.$refs.mainmap.snackbarColor = '#ff0000'
        this.$refs.mainmap.snackbarInfo = `所选区域面积小于25km²，请重新选择！`
        return;
      }
      this.axios.get("/loginapi/getUserForUserCenter",{
          headers: {
              Authorization: "Bearer " + this.getKey(),}
          }).then((res) => {
          if(res.status==200){
              const d = res.data && res.data.data;
              if (!d) {
                alert("系统错误");
                return;
              }
              const certificationIdentity = String(d.certificationIdentity);
              if (certificationIdentity === "2" || certificationIdentity === "3") {
                this.proceedCountyNextStep();
                return;
              }
              const ecRaw = d.enterpriseCertStatus;
              const ecStr = ecRaw === null || ecRaw === undefined || ecRaw === "" ? "" : String(ecRaw).trim();
              if (ecStr === "" || ecStr === "null") {
                this.shadowTip = true;
                return;
              }
              if (ecStr === "1") {
                this.jumpWithPermission("仅实名", "/store/VIPBenefits", "/rskit/buyCountyProduction");
                return;
              }
              if (ecStr === "0" || ecStr === "2" || ecStr === "3") {
                this.loadEnterpriseCertInfoForLetterModal();
                return;
              }
              this.shadowTip = true;
          }
          else {
              alert('系统错误')
          }
      })
    },
    proceedCountyNextStep() {
        this.$refs.mainmap.snackbar = true
        this.$refs.mainmap.snackbarColor = '#ff9900'
        this.$refs.mainmap.snackbarInfo = `缩略图生成中，请稍候……`
        this.$refs.mainmap.printScreen()
        this.$store.state.county.selectedQuanterIds = this.selectedQuanterIds;
        this.$store.state.county.selectedQuanterItems = this.selectedQuanterItems;
        this.$store.state.county.selectedSumPrices = this.selectedSumPrices;
        this.$store.state.county.tabSel = this.tabSel;
        this.$store.state.county.customizeName = this.customizeName;
        this.$store.state.county.shape = this.$refs.mainmap.str_wkt;
        this.$store.state.county.areaSel = this.areaSel;
    },
    mapAuthorizationLetterView(statusRaw) {
        if (statusRaw === null || statusRaw === undefined || statusRaw === "") return "initial";
        const t = String(statusRaw).trim();
        if (t === "null" || t === "undefined") return "initial";
        if (t === "未通过" || t.includes("未通过")) return "rejected";
        if (t === "审核中" || t.includes("审核中")) return "pending";
        if (t === "已通过" || t.includes("已通过")) return "proceed";
        if (t === "0" || t === 0) return "initial";
        if (t === "1" || t === 1) return "pending";
        if (t === "2" || t === 2) return "proceed";
        if (t === "3" || t === 3) return "rejected";
        return "initial";
    },
    loadEnterpriseCertInfoForLetterModal() {
        this.axios
            .get("/accessapi/enterprise/cert/getUserEnterpriseCertInfo", {
                headers: { Authorization: "Bearer " + this.getKey() },
            })
            .then((res) => {
                const body = res.data;
                const data = (body && (body.data !== undefined ? body.data : body)) || {};
                this.enterpriseCertInfoId = data.id != null ? data.id : (data.certId != null ? data.certId : null);
                this.authLetterCompanyName = (data.companyName != null ? data.companyName : "").toString().trim();
                this.authLetterCreditCode = (data.creditCode != null ? data.creditCode : "").toString().trim();
                this.authorizationLetterRejectReason = (data.authorizationLetterRejectReason || data.rejectReason || data.refuseReason || data.authorizationRefuseReason || "").toString().trim();
                this.clearAuthFile();
                this.clearAuthLetterTip();
                const mode = this.mapAuthorizationLetterView(data.authorizationLetterStatus);
                if (mode === "proceed") {
                    this.proceedCountyNextStep();
                    return;
                }
                this.authLetterModalMode = mode;
                this.authLetterModalVisible = true;
            })
            .catch(() => {
                this.$message.error("获取企业认证信息失败");
            });
    },
    showAuthLetterTip(msg, type) {
        this.authLetterTopTip = msg || "";
        this.authLetterTopTipType = type === "success" ? "success" : "error";
    },
    clearAuthLetterTip() {
        this.authLetterTopTip = "";
    },
    closeAuthLetterModal() {
        this.authLetterModalVisible = false;
        this.clearAuthFile();
        this.clearAuthLetterTip();
    },
    openAuthFilePicker() {
        if (this.$refs.authFileInput) {
            this.$refs.authFileInput.value = "";
            this.$refs.authFileInput.click();
        }
    },
    triggerAuthFileInput() {
        this.openAuthFilePicker();
    },
    onAuthDragOver() {
        this.authLetterDragOver = true;
    },
    onAuthDragLeave() {
        this.authLetterDragOver = false;
    },
    onAuthFileDrop(e) {
        this.authLetterDragOver = false;
        const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        this.applyAuthPickedFile(f);
    },
    onAuthFileChange(e) {
        const f = e.target && e.target.files && e.target.files[0];
        this.applyAuthPickedFile(f);
    },
    applyAuthPickedFile(file) {
        if (!file) return;
        this.authLetterPendingFile = file;
        this.authLetterPendingName = file.name;
    },
    clearAuthFile() {
        this.authLetterPendingFile = null;
        this.authLetterPendingName = "";
        if (this.$refs.authFileInput) {
            this.$refs.authFileInput.value = "";
        }
    },
    isAuthFileValidType(file) {
        if (!file || !file.name) return false;
        const n = file.name.toLowerCase();
        return n.endsWith(".pdf") || n.endsWith(".jpg") || n.endsWith(".jpeg") || n.endsWith(".png");
    },
    validateAuthFileForUpload() {
        const f = this.authLetterPendingFile;
        if (!f) {
            this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
            return false;
        }
        const maxBytes = 20 * 1024 * 1024;
        if (f.size > maxBytes) {
            this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
            return false;
        }
        if (!this.isAuthFileValidType(f)) {
            this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
            return false;
        }
        return true;
    },
    downloadAuthLetterTemplate() {
        if (this.authLetterTemplateLoading) {
            return;
        }
        const name = (this.authLetterCompanyName || "").trim();
        const code = (this.authLetterCreditCode || "").trim();
        if (!name || !code) {
            this.showAuthLetterTip("企业名称或统一社会信用代码缺失，请刷新页面后重试", "error");
            return;
        }
        this.authLetterTemplateLoading = true;
        this.clearAuthLetterTip();
        const fd = new FormData();
        fd.append("companyName", name);
        fd.append("creditCode", code);
        this.axios
            .post("/accessapi/enterprise/cert/getAuthorizationLetter", fd, {
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((res) => {
                const body = res.data || {};
                if (body.status === 200 && body.data) {
                    const url = typeof body.data === "string" ? body.data : (body.data.url || body.data);
                    if (url) {
                        window.open(url, "_blank");
                    } else {
                        this.showAuthLetterTip("未获取到模板地址", "error");
                    }
                } else {
                    this.showAuthLetterTip(
                        (body.message && String(body.message)) || "获取模板失败，请稍后重试",
                        "error"
                    );
                }
            })
            .catch(() => {
                this.showAuthLetterTip("获取模板失败，请稍后重试", "error");
            })
            .finally(() => {
                this.authLetterTemplateLoading = false;
            });
    },
    postAuthorizationLetter() {
        if (!this.enterpriseCertInfoId) {
            this.showAuthLetterTip("企业认证信息不完整，请刷新页面后重试", "error");
            return;
        }
        if (!this.validateAuthFileForUpload()) return;
        this.clearAuthLetterTip();
        const fd = new FormData();
        fd.append("id", this.enterpriseCertInfoId);
        fd.append("authorizationLetter", this.authLetterPendingFile);
        this.authLetterUploading = true;
        this.axios
            .post("/accessapi/enterprise/cert/uploadAuthorizationLetter", fd, {
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((res) => {
                const d = res.data || {};
                if (d.status != null && d.status !== 200) {
                    this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
                    return;
                }
                if (d.code != null && d.code !== 200 && d.code !== 0) {
                    this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
                    return;
                }
                if (d.success === false) {
                    this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
                    return;
                }
                this.showAuthLetterTip("上传成功，预计在1-3个工作日内完成审核", "success");
                this.clearAuthFile();
                this.authLetterModalMode = "pending";
            })
            .catch(() => {
                this.showAuthLetterTip("上传失败，文件大小/格式不符合要求", "error");
            })
            .finally(() => {
                this.authLetterUploading = false;
            });
    },
    confirmAuthLetterAction() {
        if (this.authLetterUploading) return;
        this.postAuthorizationLetter();
    },
    quanterListByYear(year) {
      const y = Number(year)
      const list = this.areaQuanterList
      const hasYearField = list.some(
        (item) => item.year != null && item.year !== ''
      )
      if (hasYearField) {
        return list.filter((item) => Number(item.year) === y)
      }
      if (y === 2023) return list.slice(0, 4)
      if (y === 2024) return list.slice(4, 8)
      if (y === 2025) return list.slice(8, 14)
      if (y === 2026) return list.slice(14)
      return []
    },
    clickQuanterItem(item){
      let tempQuanterItems=[]
      let tempSumPrices=0;
      if(this.selectedQuanterIds.indexOf(item.subName)>-1){
        this.selectedQuanterIds.splice(this.selectedQuanterIds.indexOf(item.subName),1)
      }else{
        this.selectedQuanterIds.push(item.subName)

        this.showVectorTileLayer = true
        this.curmk = item.mk
        this.vectorTileLayer.getSource().setUrl(`https://api.jl1mall.com/getTileMVT/{z}/{x}/{-y}?mk=${this.curmk}&tk=cd89c104f3526ec9ba3371dd900314a5`)
        this.showImageTime='隐藏拍摄时间'
        this.vectorTileLayer.setVisible(true)
        this.curyear = item.year
        this.cursort = item.sort
      }
      for(let i=0;i<this.areaQuanterList.length;i++){
        if(this.selectedQuanterIds.indexOf(this.areaQuanterList[i].subName)>-1){
          tempQuanterItems.push(this.areaQuanterList[i]);
          tempSumPrices+=this.areaQuanterList[i].price;
        }
        this.selectedQuanterItems=tempQuanterItems;
        this.selectedSumPrices=tempSumPrices;
      }
    },

    searchDetail(item,areaId) {
      this.selectedQuanterItems=[];
      this.selectedSumPrices=0;
      this.selectedQuanterIds=[]
      this.priceResult = []
      // let areaId=item.areaId
      this.beijingOrder = item.some(data => data.sort === -1);
      if(item.length>0){
        if(item[0].areaGeo) this.areaGeo = item[0].areaGeo
        this.countyNameResult = item[0].areaName
        this.countyAreaResult = item[0].area
        this.areaQuanterList=item
      }
      if(this.tabSel==3&&this.areaSel==2){
        this.countyAreaResult = 25
      }

      this.countyName = this.countyNameResult
      setTimeout(()=>{
        this.customizeName=this.countyNameResult
      },100)
      //只是记录访问信息，从countyPrices摘取
      this.axios.get('/tilesapi/tiles/county/price/queryCountyTilesInfo?areaId=' + areaId, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }).then((res) => {
      })
    },
    showDetail() {
      this.showCountyNameResult = true
      let allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
      allLayers.forEach(layer => {
        if (layer instanceof Vector && layer.values_.title=='边框') {
          layer.getSource().clear()
          let geom = JSON.parse(this.areaGeo)
          let geometry
          if (geom.type=='MultiPolygon') {
            geometry=new MultiPolygon(geom.coordinates)
          }
          if (geom.type == 'Polygon') {
            geometry=new Polygon(geom.coordinates)
          }
          if (geom.type == 'LineString') {
            geometry=new LineString(geom.coordinates)
          }
          if (geom.type == 'MultiLineString') {
            geometry=new MultiLineString(geom.coordinates)
          }
          let feature=new Feature({
            geometry: geometry
          })
          feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
          layer.getSource().addFeature(feature)
          let ext = layer.getSource().getExtent()
          this.$refs.mainmap.map.getView().fit(ext)
        }
      })
    },
    checkScreenWidth() {
      let screenWidth = window.innerWidth;
      if (screenWidth < 800) {
        this.computerOrPhone = 'phone';
        //根据屏幕大小设置rem
        // 计算屏幕宽度
        let screen = document.documentElement.clientWidth;
        // 计算字体大小，取屏幕宽度的16分之一
        let scale = screen / 375;//当前屏幕与设计稿比例
        let size = scale * 16;
        // 设置根元素字体大小
        document.documentElement.style.fontSize = size + 'px';
      } else {
        document.documentElement.style.fontSize = '16px';
        this.computerOrPhone = 'computer';
      }
    },
    searchCountyByName() {
      if (this.countyName) {
        this.axios.get('/tilesapi/tiles/county/script/getDomesticAreaEsInfoByIndex?areaName=' + this.countyName, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }).then((res) => {
              this.priceResult = []
              res.data.data.forEach(item => {
                this.priceResult.push(item)
              })
            })
      }
    },
    searchCountyById() {
      let areaId = this.chinaCountyNow || this.chinaCityNow || this.chinaProvinceNow
      console.log(areaId);
      this.axios.get('/tilesapi/tiles/county/price/queryCountyTilesList?areaId=' + areaId, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
          .then((res) => {
            let item = res.data.data
            this.searchDetail(item,areaId)
            this.showDetail()
          })
    },
    selectExplainPlace(item){
      this.priceResult = []
      this.countyName = item.completeArea
      this.axios.get('/tilesapi/tiles/county/price/queryCountyTilesList?areaId=' + item.areaId, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }).then((res) => {
          let item1 = res.data.data
          this.searchDetail(item1,item.areaId)
          this.showDetail()
        })
    },
    extractPolygons(input) { //将输入geojson拆分成多个polygon
      // 标准化输入为FeatureCollection
      let features;
      const type = input.type;
      if (type === 'FeatureCollection') {
        features = input.features;
      } else {
        features = [turf.feature(input)];
      }
      // 拆解所有Multi类型几何体
      const flattened = flatten(turf.featureCollection(features));

      // 收集所有Polygon的坐标
      const polygons = [];
      for (const feature of flattened.features) {
        const geomType = feature.geometry.type;
        if (geomType === 'Polygon') {
          polygons.push(feature.geometry.coordinates);
        }
      }

      if (polygons.length === 0) {
        throw new Error('输入的矢量中未找到任何多边形');
      }

      return polygons.map(coords => turf.polygon(coords));
    },
    //查询绘制区域
    queryCountyTilesListByShape(){
      if(this.canQueryArea||this.canQueryVector==true){
        //我需要shape
        this.areaGeo = this.$refs.mainmap.str_wkt

        // 判断是否处于北京市内
        let areaGeojson = WKT.parse(this.areaGeo)
        let feature1 = this.extractPolygons(this.beijingGeo)[0]
        feature1 = turf.buffer(feature1, 2.5, 'kilometers')
        let feature2 = this.extractPolygons(areaGeojson)
        let boolIntersect = true
        feature2.forEach(feature => {
          if (!booleanContains(feature1, feature)) {
            boolIntersect = false
          }
        });
        let shape = this.str_point
        let area = this.$refs.mainmap.str_area
        let formData = new FormData();
        formData.append("shape", shape);
        formData.append("area", area);
        formData.append("inBeijing", boolIntersect);
        this.axios.post(
            "/tilesapi/tiles/county/price/queryCountyTilesListByShape",formData,
            {headers: {
                Authorization: "Bearer " + this.getKey(),
            },}
        ).then((res) => {
            let item = res.data.data
            this.searchDetail(item,item[0].areaId)
            this.showCountyNameResult = true
        });
      }
    },
    cancelArea(){
      this.canQueryArea=false
      this.canQueryVector=false
      this.showCountyNameResult = false
      this.areaSel=0
      //把你的绘制区域的内容清空
      bus.$emit('clean')
    },
    showVectorLayer(){
      if(this.vectorTileLayer){
        if(this.showImageTime=='显示拍摄时间'){
          this.showImageTime='隐藏拍摄时间'
          this.vectorTileLayer.setVisible(true)
        }
        else{
          this.showImageTime='显示拍摄时间'
          this.vectorTileLayer.setVisible(false)
        }
      }
    },
    loadVectorTile(){
      this.$refs.mainmap.map.removeLayer(this.vectorTileLayer)
      this.vectorTileLayer=new VectorTileLayer({
        source: new VectorTile({
          format: new MVT(),
          url: `https://api.jl1mall.com/getTileMVT/{z}/{x}/{-y}?mk=73ad26c4aa6957eef051ecc5a15308b4&tk=cd89c104f3526ec9ba3371dd900314a5`
          // url: `https://api.jl1mall.com/getTileMVT/{z}/{x}/{-y}?mk=${this.curmk}`
        }),
        style: this.customStyleFunction,
        minZoom:10,
        maxZoom:15,
        visible:false,
        zIndex: 1
      })
      this.$refs.mainmap.map.addLayer(this.vectorTileLayer)
    },
    customStyleFunction(feature,resolution){
      const defaultStyle = new Style({
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.01)'
        }),
        stroke: new Stroke({
          color: '#319FD3',
          width: 1
        })
      });
      const selectStyle = new Style({
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.01)'
        }),
        stroke: new Stroke({
          color: '#319FD3',
          width: 1
        }),
        text: new Text({
          font: '12px Tensentype-ZhiHeiJ-W2',
          stroke: new Stroke({
            color: '#3D99C1',
            width: 1,
          }),
          fill: new Fill({
            color: 'rgba(255, 255, 255, 1)',
          }),
          backgroundFill: new Fill({
            color: 'rgba(0,0,0,0.34)',
          }),
          padding: [2, 5, 2, 5],
          text: feature.properties_.imagingTime,
          overflow:true
        })
      });
      const redStyle = new Style({
        fill: new Fill({
          color: 'rgba(224,32,32,0.1)'
        }),
        stroke: new Stroke({
          color: '#E02020',
          width: 2
        }),
        text: new Text({
          font: '12px Tensentype-ZhiHeiJ-W2',
          stroke: new Stroke({
            color: '#E02020',
            width: 1,
          }),
          fill: new Fill({
            color: 'rgba(255, 255, 255, 1)',
          }),
          backgroundFill: new Fill({
            color: 'rgba(0,0,0,0.34)',
          }),
          padding: [2, 5, 2, 5],
          text: feature.properties_.imagingTime
        }),
        zIndex: 1
      });

      try {
        // let coordinates = Array.from(feature.flatCoordinates_)
        // let coorArr = []
        // for (let i = 0; i < coordinates.length; i=i+2) {
        //   coorArr.push([coordinates[i],coordinates[i+1]])
        // }
        // let geom = new Feature({
        //   geometry: new Polygon([coorArr])
        // })
        // geom.getGeometry().transform('EPSG:3857', 'EPSG:4326')
        // let geoJSONGeometry = JSON.parse(new GeoJSON().writeFeature(geom));//转为geojson

        // let isinsect = turf.intersect(geoJSONGeometry,JSON.parse(this.areaGeo))

        let ymd = feature.properties_.imagingTime
        if(ymd){
          ymd = ymd.split(' ')[0].split('-')
          if(ymd[0]!=this.curyear) return redStyle
          else if(this.curyear=='2025'){
            if(ymd[1]<this.cursort*2-1) return redStyle
            else return selectStyle
          }
          else if(this.curyear=='2023'||this.curyear=='2024'){
            if(ymd[1]<this.cursort*3-2) return redStyle
            else return selectStyle
          }
        }
      } catch (error) {
        return
      }
    },
    changeFn() {
      document.getElementById("filesForBuy").click();
    },
    importFile() {
      var selectedFile = document.getElementById("filesForBuy").files[0];//获取读取的File对象
      this.fileReader(selectedFile);
      this.canQueryVector=false
    },
    fileReader(file) {
      if (["kml","kmz","zip"].includes(file.name.slice(-3))) {
        let data = new FormData();
        data.append('file', file);
        // this.overlay=true
        this.axios({
            method: 'post',
            timeout: 100000,
            url: '/koa_back/makeGeoValid',
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data:data
        }).then((res) => {
          let geoJson = JSON.parse(res.data.validjson);

          // TODO 创建矢量时是不做限制的，只有在项目中选择时做限制
          if (!["Polygon","MultiPolygon"].includes(geoJson.type)) {
            this.$message.warning('暂不支持使用点或线矢量裁剪，请重新上传！')
            return
          }
          this.$refs.mainmap.needEmit = true

          bus.$emit('showUploadVector',geoJson)

          let formdata = new FormData()
          let geom=JSON.stringify(geoJson)
          formdata.append("geom",geom)
          this.axios
          .post("/map_service_back/program/geomAreaHandle", formdata, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then(res => {
            if(res.data.message=='当前矢量中要素数量超过10个，暂不能用于创建项目')
              this.$message.warning('当前矢量中要素数量超过10个，暂不能用于购买区域')
            else
              this.$refs.mainmap.makeBufferRegion(res)
          }).catch(error => {
            this.$message.error('矢量解析失败')
          })
        })
      }else{
        this.$message.warning('请检查文件类型，目前只支持.kml .kmz .zip(需包含.shp和.prj)')
      }
    },
    customizeNameAdd(){
      if(this.customizeName.length>0){
        if(this.customizeName.slice(-6)!='（自选区域）'){
          this.customizeName=this.customizeName+'（自选区域）'
        }
      }

    },
    //用户信息回显
    getUserData(){
      let authentication=localStorage.getItem('authentication')
      let loginUserId=localStorage.getItem('userId')
      if(authentication==0||authentication=='0'){
        if(this.$store.state.county.name==''|| this.$store.state.county.name==null||this.$store.state.county.sex==''|| this.$store.state.county.sex==null||this.$store.state.county.age==''||
            this.$store.state.county.age==null||this.$store.state.county.education==''|| this.$store.state.county.education==null||this.$store.state.county.company==''|| this.$store.state.county.company==null){
              this.axios.post("/tilesapi/queryUserInfo",null, {
                  headers: {Authorization: "Bearer " + this.getKey(),},
              }).then((res)=>{
                  let data = res.data.data
                  this.$store.state.county.name=data.name
                  this.$store.state.county.sex=data.sex
                  this.$store.state.county.age=data.age
                  this.$store.state.county.education=data.education
                  this.$store.state.county.company=data.company
                  if(data.name==''|| data.name==null||data.sex==''|| data.sex==null||data.age==''||
                    data.age==null||data.education==''|| data.education==null||data.company==''|| data.company==null){
                      this.$router.push({path: "/Purchase",query: {'processType':8}});
                  }
              })
          }
      }else{
        if(loginUserId){
            this.jumpWithPermission('仅实名','/Authentication','/rskit/Purchase?processType=8')
        }else{
          this.jumpWithPermission('仅登录','/Login','/rskit/Purchase?processType=8')

        }
      }
      let useCode = this.$route.query.useCode;
      if(useCode.includes("nowUse")){
        this.curPlaceTab=2
        this.tabSel=3
        this.areaSel=0
      }
    },
  },
  watch: {
    curPlaceTab() {
      this.priceResult = []
      this.showCountyNameResult = false
      this.countyName = ''
      this.countyNameResult = ''
      this.countyAreaResult = ''
      this.areaGeo = ''
    },
    chinaProvinceNow() {
      this.chinaCityNow = ''
      this.chinaCountyNow = ''
      this.chinaCityItems = []
      this.chinaCountyItems = []
      this.$refs.chinaCity ? this.$refs.chinaCity.lazySearch = '' : '';
      this.$refs.chinaCounty ? this.$refs.chinaCounty.lazySearch = '' : '';
      if (this.chinaProvinceNow !== '') {
        this.axios.get('/accessapi/searchService/Area/id=' + this.chinaProvinceNow)
            .then((res) => {
              this.chinaCityItems = res.data.data
            })
        let selected = this.chinaProvinceItems.find((x) => {
          return x.areaId === this.chinaProvinceNow
        });
        this.selectedProvinice = selected.areaName;
        this.$store.state.search.selectedRangeStore['china'] = JSON.parse(selected.areaGeojson)
        this.explainPlace = this.selectedProvinice;
      }
    },
    chinaCityNow() {
      this.chinaCountyNow = ''
      this.chinaCountyItems = []
      this.$refs.chinaCounty ? this.$refs.chinaCounty.lazySearch = '' : '';
      if (this.chinaCityNow !== '') {
        this.axios.get('/accessapi/searchService/Area/id=' + this.chinaCityNow)
            .then((res) => {
              this.chinaCountyItems = res.data.data
            })
        let selected = this.chinaCityItems.find((x) => {
          return x.areaId === this.chinaCityNow
        });
        this.selectedCity = selected.areaName;
        this.$store.state.search.selectedRangeStore['china'] = JSON.parse(selected.areaGeojson)
        this.explainPlace = this.selectedProvinice + this.selectedCity;
      }

    },
    chinaCountyNow() {
      if (this.chinaCountyNow !== '') {
        let selected = this.chinaCountyItems.find((x) => {
          return x.areaId === this.chinaCountyNow
        });
        this.selectedCounty = selected.areaName;
        this.$store.state.search.selectedRangeStore['china'] = JSON.parse(selected.areaGeojson)
        this.explainPlace = this.selectedProvinice + this.selectedCity + this.selectedCounty;
      }
    },
    customizeName(newVal){
      if(this.tabSel==3||this.tabSel==4){
        if(newVal.length<=0){
          let areaNameInputId = document.getElementById('areaNameInputId')
          areaNameInputId.style.borderBottom='1px solid #F35656'
          let itemTextId = document.getElementById('itemTextId')
          itemTextId.style.color='#F35656'

        }else{
          let areaNameInputId = document.getElementById('areaNameInputId')
          areaNameInputId.style.borderBottom='1px solid rgba(215,215,215,0.4)'
          let itemTextId = document.getElementById('itemTextId')
          itemTextId.style.color='#979797'
        }
      }
    },
    tabSel(){
      this.foreanHint=false
    },
    areaSel(newVal){
      this.canQueryArea=false
      this.canQueryVector=false
      this.showCountyNameResult = false
      bus.$emit('clean')
      if(newVal==1){
        bus.$emit('buyArea','rec')
      }
      else if(newVal==2){
        this.$refs.mainmap.drawArea()
      }
      else if(newVal==3){
        bus.$emit('buyArea','area')
      }
    }

  }
}
</script>

<style scoped lang="scss">
.dialogMantle {
  z-index: 1000000000;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(80, 80, 80, 0.5);

  .dialogCtn {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -400px;
    margin-top: -200px;
    width: 800px;
    height: 400px;
    background: #FFFFFF;
    border-radius: 16px;
    .dialogTitle{
      width:100%;
      height:30px;
      line-height: 30px;
      text-align: center;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #3A3A3A;
    }
    .dialogTxt{
      height:25px;
      line-height: 25px;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 100%;
      font-weight: 300;
      color: #575757;
    }
    .dialogTxt1{
      margin-left: 70px;
      height:25px;
      line-height: 25px;
      text-align: left;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 100%;
      font-weight: 300;
      color: #575757;
    }
    img {
      position: absolute;
      right: -55px;
      top: 0px;
      cursor: pointer;
    }
  }

}

.bottomTip {
 position:relative;
  margin-left:15px;
  margin-top:10px;
  width: 560px;
  height: 54px;
  background: #F7F7F7;
  border-radius: 8px;
  line-height: 54px;
  text-align: center;
  color: #3a3a3a;
}
.bottomTipAboslute{
  position:absolute;
  left:15px;
  bottom:10px;
  width: 560px;
  height: 54px;
  background: #F7F7F7;
  border-radius: 8px;
  line-height: 54px;
  text-align: center;
  color: #3a3a3a;
}

.commitCtn {
  height: 45px;
  width: 560px;
  display: flex;
  justify-content: start;
  margin-left: 15px;
  margin-top: 20px;
  padding-left: 10px;
}

.quarterSelectCtn {
  width: 560px;
  height: auto;
  max-height: 360px;
  margin-left: 15px;
  border-bottom: 1px dashed rgba(0, 0, 0, .1);
  padding-top: 5px;
  padding-left: 5px;
  overflow-y: auto;
  overflow-x: hidden;

  .selectItem-selected {
    position: relative;
    cursor: pointer;
    width: 95%;
    height: 54px;
    padding-left: 30px;
    padding-right: 20px;
    line-height: 54px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 2px solid #0066CC;
    margin-bottom: 20px;
  }

  .selectItem {
    position: relative;
    cursor: pointer;
    width: 95%;
    height: 54px;
    padding-left: 30px;
    padding-right: 20px;
    line-height: 54px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #979797;
    margin-bottom: 20px;
  }

  .icon {
    position: absolute;
    right: 20px;
    top: 19px;
  }
}

.mianCtn {
  position: relative;
  width: 100vw;
  min-width: 1100px;
  height: calc(100% - 76px);
  margin-top: 76px;
  .leftCtn {
    position: relative;
    margin-left: 0;
    width: calc(100% - 605px);
    height: 100%;
    float: left;
  }
  .rightCtn {
    position: relative;
    width: 605px;
    height: 100%;
    float: left;
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 10px;

    .rightTitle {
      width: 100%;
      height: 42px;
      font-size: 30px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #3A3A3A;
      line-height: 42px;
      text-align: center;
      margin-top: 30px;
      margin-bottom: 30px;
    }
  }
}

.topTips {
  position: relative;
  top: 76px;
  width: 100%;
  height: 76px;
  background: #F5F5F6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  div {
    width: 532px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 20px;
    text-align: center;
  }
}

.queryDiv {
  position: relative;
  top: 76px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.title {
  // width: 330px;
  height: 42px;
  font-size: 30px !important;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 42px;
  margin: 50px 0;
}

.mainPanel {
  width: 1280px;
  height: 480px;
  display: flex;
}

.mapPanel {
  width: 100%;
  height: 100%;
}

.detailPanel {
  width: 640px;
  border-radius: 0px 32px 32px 0px;
  background: #F7F7F7;
}

.priceResultList {
  position: absolute;
  top: -35px;
  left: 0px;
  width: 394px;
  border-radius: 8px;
  border: 1px solid #979797;
  background: #ffffff;
  max-height: 320px;
  overflow-y: scroll;
}
.priceResultList::-webkit-scrollbar {/*滚动条整体样式，pageLeftNav是类的名称*/
  width: 5px;     /*高宽分别对应横竖滚动条的尺寸*/
  height: 0px;
}
.priceResultList::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
  border-radius: 1.5px;
  -webkit-box-shadow: inset 0 0 5px rgb(147, 148, 148);
  background: #cccccc;
}
.priceResultList::-webkit-scrollbar-track {/*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(117, 117, 117, 0.1);
  border-radius: 10px;
  background: rgba(238, 238, 238, 0.17);
  border-radius: 0px 10px 10px 0px;
}
.detail {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 20px 0 0 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 20px;
  width: 558px;

  span {
    color: #3A3A3A;
    margin-left: 10px;
  }

  .item {
    width: 100%;

    div {
      height: 30px;

      .rmb {
        color: #3A3A3A;
      }

      .price {
        color: #FF4040;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        margin-left: unset;
      }
    }
  }
}


::v-deep .vtabs {
  // border-radius: 4px;
  // background: #3A3A3A;
  margin-left: 10px;

  & .v-window__container {
    border-top: solid 1px #cccccc;
  }

  & .v-tabs {
    width: unset;
  }

  & .v-tab {
    // width: 100px;
    // height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
  }

  // & .v-tabs-bar{
  //     width: 30%;
  // }
  & .v-tabs--grow > .v-tabs-bar .v-tab {
    flex: unset !important;
  }

  & .v-slide-group__content,
  & .v-slide-group__wrapper {
    flex: unset !important;
  }

  & .v-tabs-slider {
    width: 80%;
    margin-left: 10%;
  }

  &.vtabs-year-select {
    & .v-tabs,
    & .v-tabs-bar,
    & .v-tabs-bar__content {
      width: 100%;
    }

    & .v-slide-group__wrapper,
    & .v-slide-group__content {
      flex: 1 1 auto !important;
      width: 100% !important;
    }

    & .v-slide-group__content {
      display: flex !important;
      justify-content: stretch;
    }

    & .v-tabs-bar__content {
      justify-content: stretch;
    }

    & .v-tab.year-version-tab {
      flex: 1 1 0% !important;
      min-width: 0 !important;
      max-width: none !important;
      justify-content: center;
      padding: 0 8px;
    }

    & .v-tabs-slider {
      width: 100% !important;
      margin-left: 0 !important;
    }
  }

  & .v-text-field > .v-input__control > .v-input__slot:before,
  & .v-text-field > .v-input__control > .v-input__slot:after {
    border-style: unset;
  }

  & textarea {
    // height: 100% !important;
    min-height: 224px;
    max-height: 224px;
    margin: 0 20px;
  }

  & .v-counter {
    margin-right: 20px;
  }

  & label {
    font-size: 14px;
  }

  & .theme--light.v-tabs-items {
    background-color: unset;
    height: 100%;
  }

  & .v-window-item .searchField {
    padding-top: 27px;
    width: 100%;
    display: flex;
    justify-content: left;
  }

  & .v-window-item {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  & .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 44px;
  }

  & .v-text-field--outlined .v-label {
    top: 12px;
  }

  & .v-text-field--full-width .v-input__prepend-outer, .v-text-field--full-width .v-input__prepend-inner, .v-text-field--full-width .v-input__append-inner, .v-text-field--full-width .v-input__append-outer, .v-text-field--enclosed .v-input__prepend-outer, .v-text-field--enclosed .v-input__prepend-inner, .v-text-field--enclosed .v-input__append-inner, .v-text-field--enclosed .v-input__append-outer {
    margin-top: 10px;
  }
}

::v-deep .ant-list-split .ant-list-item {
  border-bottom: unset;
  padding: 6px 0;
}

::v-deep .ant-list-items {
  padding-left: 6px !important;
}

</style>
<style scoped>
.drawAreaCon{
  position: relative;
  margin-top: 10px;
  width: 100%;
  height: 88px;
}
.areaSel{
  position: relative;
  float: left;
  width: 104px;
  height: 81px;
  margin-right: 20px;
  cursor: pointer;
}
.areaButtonCon{
  position: absolute;
  width: 81px;
  height: 81px;
  right: 60px;
}
.areaButton1{
  position: absolute;
  top: 0;
  left: 0;
  width: 81px;
  height: 36px;
  background: #6A6A6A;
  border-radius: 6px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
}
.areaButton1-s{
  position: absolute;
  top: 0;
  left: 0;
  width: 81px;
  height: 36px;
  background: #2F66CC;
  border-radius: 6px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
}
.redHint{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 56px;
  background: rgba(0,0,0,0.34);
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 56px;
  text-align: left;
  padding-left: 40px;
}
.areaButton2{
  position: absolute;
  top: 45px;
  left: 0;
  width: 81px;
  height: 36px;
  border: 1px solid #6A6A6A;
  border-radius: 6px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #6A6A6A;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
}
.areaButton2-s{
  position: absolute;
  top: 45px;
  left: 0;
  width: 81px;
  height: 36px;
  border: 1px solid #2F67CC;
  border-radius: 6px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #2F66CC;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
}
.drawAreaTip{
  position: relative;
  padding-left: 12px;
  margin-top: 6px;
  width:100%;
  height: 11px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #3A3A3A;
  line-height: 11px;
  text-align: left;
  font-style: normal;
}
.foreanHintText{
  position: absolute;
  top:280px;
  left: 14px;
  padding-left: 12px;
  margin-top: 6px;
  width:100%;
  height: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: red;
  line-height: 16px;
  text-align: left;
  font-style: normal;
}
.areaNameInput{
  position: absolute;
  top:-4px;
  left: 80px;
  width: 470px;
  height: 25px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #7F7F7F;
  line-height: 25px;
  text-align: left;
  border-bottom:1px solid rgba(215,215,215,0.4);
  outline: none;
}
.itemText{
  position: absolute;
  width:auto;
  height: 17px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #979797;
  line-height: 16px;
}
.itemTip{
  position: absolute;
  left: 80px;
  top:21px;
  width: 150px;
  height: 11px !important;;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 8px;
  color: #7F7F7F;
  line-height:11px;
  text-align: left;
}
.drawAreaConImg{
  position: absolute;
  left: 15px;
  width: 341px;
  height: 81px;
  cursor: pointer;
}
</style>
<style scoped>
.shadow{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000001;
    background: rgba(0,0,0,0.4);
}
.shadowWhite{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 776px;
    height: 428px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #979797;
}
.shadowClose{
    position: absolute;
    top: 28px;
    right: 40px;
    width: 20px;
    z-index: 1;
    font-size: 32px;
    color: #000000;
    cursor: pointer;
}
.shadowText1{
    position: absolute;
    top: 32px;
    width: 100%;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
    text-align: center;
}
.shadowText2{
    position: absolute;
    top: 88px;
    left: 64px;
    width: 648px;
    height: 64px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 32px;
}
.shadowSel{
    position: absolute;
    top: 192px;
    left: 100px;
    width: 276px;
    height: 157px;
    cursor: pointer;
    background: rgba(0,0,0,0.4);
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 10px;
    overflow: hidden;
}
.shadowSel:hover{
    border: 2px solid #1890FF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 10px;
}
.authLetterLayer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000002;
    pointer-events: auto;
}
.authLetterTopTip {
    position: absolute;
    top: 20px;
    left: 16px;
    right: 16px;
    z-index: 2;
    text-align: center;
    box-sizing: border-box;
    pointer-events: none;
}
.authLetterTopTipInner {
    display: inline-flex;
    align-items: flex-start;
    gap: 8px;
    max-width: 90%;
    padding: 10px 16px;
    border-radius: 4px;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.12);
    pointer-events: auto;
    text-align: left;
}
.authLetterTopTipInner--success {
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    color: rgba(0,0,0,0.88);
}
.authLetterTopTipInner--error {
    background: #fff2f0;
    border: 1px solid #ffccc7;
    color: rgba(0,0,0,0.88);
}
.authLetterTopTipText {
    line-height: 1.4;
    word-break: break-word;
}
.authLetterTopTipMark {
    flex-shrink: 0;
    font-weight: 700;
    line-height: 1.2;
}
.authLetterTopTipInner--success .authLetterTopTipMark {
    color: #52c41a;
}
.authLetterTopTipInner--error .authLetterTopTipMark {
    color: #ff4d4f;
}
.authLetterShadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(0,0,0,0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    box-sizing: border-box;
}
.authLetterModal {
    position: relative;
    width: 600px;
    max-width: 100%;
    max-height: 90vh;
    overflow: auto;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.12);
    padding: 28px 32px 32px;
    box-sizing: border-box;
}
.authLetterClose {
    position: absolute;
    top: 20px;
    right: 24px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    z-index: 1;
}
.authLetterTitle {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: rgba(0,0,0,0.88);
    margin-bottom: 16px;
    padding-right: 32px;
}
.authLetterDesc {
    text-align: center;
    font-size: 15px;
    line-height: 1.6;
    color: rgba(0,0,0,0.65);
    margin-bottom: 20px;
}
.authLetterReject {
    text-align: center;
    font-size: 14px;
    line-height: 1.5;
    color: rgba(0,0,0,0.45);
    margin-bottom: 20px;
}
.authLetterDrop {
    border: 1px dashed #c9cdd4;
    background: #fafafa;
    border-radius: 8px;
    padding: 32px 16px 28px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 12px;
    transition: background 0.2s, border-color 0.2s;
}
.authLetterDrop--active {
    background: #f0f7ff;
    border-color: #1E81EB;
}
.authLetterFileInput {
    display: none;
}
.authLetterDropIcon {
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
}
.authLetterDropLine1 {
    font-size: 15px;
    color: rgba(0,0,0,0.88);
    margin-bottom: 8px;
}
.authLetterDropLine2 {
    font-size: 12px;
    color: rgba(0,0,0,0.45);
}
.authLetterFileRow {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(0,0,0,0.45);
    margin-bottom: 4px;
    padding: 0 4px;
}
.authLetterFileClip {
    margin-right: 6px;
    font-size: 14px;
}
.authLetterFileName {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.authLetterFileRemove {
    margin-left: 8px;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
    color: #999;
}
.authLetterFileRemove:hover {
    color: #333;
}
.authLetterBar {
    height: 2px;
    background: #1E81EB;
    border-radius: 1px;
    margin: 0 0 12px 0;
}
.authLetterLink {
    display: block;
    text-align: center;
    color: #1E81EB;
    font-size: 15px;
    margin-bottom: 24px;
    cursor: pointer;
    text-decoration: none;
}
.authLetterLink:hover {
    text-decoration: underline;
}
.authLetterLink--disabled {
    color: #bfbfbf !important;
    cursor: not-allowed;
    pointer-events: none;
}
.authLetterBtns {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 16px;
}
.authLetterBtn1 {
    min-width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #1E81EB;
    color: #fff;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
    padding: 0 24px;
    border: none;
}
.authLetterBtn1--disabled {
    opacity: 0.55;
    cursor: not-allowed;
}
.authLetterBtn2 {
    min-width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #fff;
    color: rgba(0,0,0,0.45);
    font-size: 16px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
    padding: 0 24px;
}
</style>
